export default "__VITE_ASSET__JK$lDRY___"